const o = {
  accordion: {
    boxShadow: "none",
    "& .MuiTypography-root": {
      fontFamily: "Inter"
    },
    "&.MuiAccordion-root:first-of-type": {
      borderRadius: "8px"
    },
    "&.MuiAccordion-root:last-of-type": {
      borderRadius: "8px"
    },
    "&.MuiAccordion-root::before": {
      display: "none"
    },
    "& .summary-container": {
      display: "flex",
      flexDirection: "column",
      width: "100%"
    },
    "& .MuiAccordionSummary-content.Mui-expanded": {
      minHeight: "max-content",
      margin: 0
    },
    "& .MuiAccordionSummary-root": {
      padding: 0,
      minHeight: "max-content",
      alignItems: "flex-start"
    },
    "& .MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "max-content"
    },
    "& .MuiAccordionSummary-content": {
      margin: 0,
      width: "100%"
    },
    "&.accordion-detailed": {
      padding: "16px",
      border: "1px solid #E6E6E6",
      backgroundColor: "#F7F7F7",
      "& .summary-content": {
        marginTop: "20px"
      },
      ".MuiAccordionSummary-root.Mui-expanded": {
        minHeight: "max-content"
      },
      "&.Mui-expanded": {
        backgroundColor: "#FFFFFF",
        borderColor: "#226A58"
      },
      "& .MuiAccordionDetails-root": {
        padding: 0
      }
    },
    "&.accordion-compact": {
      backgroundColor: "#E6E6E6",
      "& .MuiAccordionSummary-root": {
        padding: "10px 16px",
        alignItems: "center"
      },
      "& .accordion-separator": {
        display: "none"
      },
      "& .MuiAccordionDetails-root": {
        padding: "16px",
        backgroundColor: "#FFFFFF",
        border: "1px solid #DCE0E6",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
      }
    }
  },
  accordionDivider: {
    marginTop: "16px",
    marginBottom: "16px",
    borderColor: "#EBEBEB"
  },
  accordionTitle: {
    color: "#5A5A5A",
    fontSize: "12px",
    fontWeight: "500",
    lineHeight: "15px"
  },
  accordionSubTitle: {
    color: "#747982",
    fontSize: "12px",
    fontWeight: "400",
    lineHeight: "14.5px",
    marginTop: "8px"
  }
};
export {
  o as styles
};
